// Mock data for Wealth Secret — all data here is MOCKED for the frontend teaser.
// This will later be replaced by real backend / API data.

export const brand = {
  name: "Wealth Secret",
  tagline: "WEALTH SECRET — DATA TERMINAL v1.0",
  version: "v1.0",
};

export const navItems = [
  { key: "command-center", label: "Command Center", icon: "LayoutGrid", path: "/" },
  { key: "ai-journal", label: "AI Journal", icon: "BookOpen", path: "/ai-journal" },
  { key: "ws-ai-chart", label: "WS Chart", icon: "LineChart", path: "/ws-ai-chart" },
  { key: "ws-ai-coach", label: "WS Coach", icon: "Sparkles", path: "/ws-ai-coach" },
  { key: "analytics", label: "WS Portfolio Doctor", icon: "BarChart3", path: "/analytics" },
  { key: "ws-news-pro", label: "WS News Pro", icon: "Newspaper", path: "/ws-news-pro" },
  { key: "community", label: "Community", icon: "Users", path: "/community" },
  { key: "ws-vip", label: "WS VIP Community", icon: "Crown", path: "/ws-vip", vip: true },
  { key: "growth-zone", label: "Growth Zone", icon: "Trophy", path: "/growth-zone" },
  { key: "ws-leaderboard", label: "WS Leaderboard", icon: "Medal", path: "/ws-leaderboard" },
  { key: "ws-ai-indicator", label: "WS AI Indicator", icon: "Radar", path: "/ws-ai-indicator", soon: true },
  { key: "ws-giveaway-zone", label: "WS Giveaway Zone", icon: "Gift", path: "/ws-giveaway-zone" },
];

export const marketSentiment = {
  state: "Composed",
  descriptor: "Calm",
  avgVolatility: "0.389%",
  message: "Calm market — tight ranges reward patience. Protect capital today.",
};

export const aiPulse = {
  source: "Live • GPT",
  headline: "XRP & ADA Awaken, BTC Cools — Is Altcoin Season Knocking?",
  bias: "Mixed",
  keyMoves: [
    "XRP/USDT: +2.40% — solid momentum building, watch the $1.50 resistance closely.",
    "BTC/USDT: -0.71% — the king pauses, giving altcoins breathing room today.",
    "ADA/USDT: +1.53% — quiet accumulation, rotation into low-caps is underway.",
  ],
  tradeIdeas: [
    "Long XRP/USDT near $1.40 with a tight stop, target $1.55 — momentum is on your side.",
    "Accumulate ADA spot in the $0.22 zone on BTC weakness, keep SL at $0.21.",
  ],
  warning:
    "Forex pairs are flat and BTC is soft — avoid forced trades. When the market is calm, preserve capital and wait for a clean setup.",
};

export const livePrices = [
  { symbol: "BTC/USDT", price: "78,669", change: -0.53 },
  { symbol: "ETH/USDT", price: "2,497.62", change: 0.32 },
  { symbol: "SOL/USDT", price: "104.12", change: 0.32 },
  { symbol: "XRP/USDT", price: "1.4359", change: 2.82 },
  { symbol: "ADA/USDT", price: "0.2253", change: 2.20 },
  { symbol: "DOGE/USDT", price: "0.0904", change: -0.05 },
  { symbol: "AVAX/USDT", price: "8.035", change: -0.46 },
  { symbol: "LINK/USDT", price: "12.71", change: -0.30 },
  { symbol: "XAU/USD", price: "4,386", change: -0.76 },
  { symbol: "EUR/USD", price: "1.1623", change: 0.04 },
  { symbol: "GBP/USD", price: "1.3539", change: 0.02 },
  { symbol: "USD/JPY", price: "154.415", change: -0.03 },
  { symbol: "AUD/USD", price: "0.7219", change: 0.01 },
  { symbol: "USD/CAD", price: "1.3812", change: 0.02 },
  { symbol: "USD/CHF", price: "0.8092", change: -0.01 },
  { symbol: "NZD/USD", price: "0.5881", change: 0.03 },
  { symbol: "EUR/JPY", price: "179.476", change: 0.05 },
  { symbol: "GBP/JPY", price: "209.055", change: 0.06 },
  { symbol: "AUD/JPY", price: "111.465", change: 0.02 },
  { symbol: "CHF/JPY", price: "190.814", change: 0.01 },
  { symbol: "CAD/JPY", price: "111.80", change: 0.02 },
  { symbol: "EUR/GBP", price: "0.8585", change: -0.01 },
];

export const featureCards = [
  { title: "Snap-to-Journal", desc: "Upload a chart, AI fills your journal", icon: "Camera" },
  { title: "Cool-Down Wall", desc: "Auto-freeze trading after 2 losses", icon: "Snowflake" },
  { title: "Pattern-IQ Scanner", desc: "Describe a chart, AI rates the setup", icon: "ScanSearch" },
  { title: "Wealth Ranks", desc: "Bronze → Diamond progression", icon: "Gem" },
  { title: "Victory Reel", desc: "Auto-generate profit highlight reels", icon: "Clapperboard" },
  { title: "Forex Calendar", desc: "Live high-impact economic events", icon: "CalendarClock" },
];

// AI Journal mock
export const journalEntries = [
  { id: 1, pair: "XRP/USDT", side: "Long", result: "Win", pnl: "+$420", r: "+2.1R", date: "8 Sep", note: "Clean breakout above $1.40, held with tight stop. Momentum confirmed." },
  { id: 2, pair: "BTC/USDT", side: "Short", result: "Loss", pnl: "-$180", r: "-1.0R", date: "7 Sep", note: "Faded resistance too early. Should have waited for rejection candle." },
  { id: 3, pair: "SOL/USDT", side: "Long", result: "Win", pnl: "+$260", r: "+1.4R", date: "6 Sep", note: "Rotation play, good entry on retest. Discipline held." },
  { id: 4, pair: "ADA/USDT", side: "Long", result: "Break-even", pnl: "$0", r: "0.0R", date: "5 Sep", note: "Choppy tape, exited at entry. Right call to protect capital." },
];

export const journalStats = {
  winRate: 68,
  disciplineScore: 82,
  totalTrades: 124,
  netPnl: "+$3,420",
};

// Guardrails mock
export const guardrails = [
  { title: "Daily Loss Limit", value: "$300", status: "Active", desc: "Trading auto-freezes when hit", icon: "OctagonAlert" },
  { title: "Cool-Down Wall", value: "2 losses", status: "Active", desc: "Forced 30-min break after streak", icon: "Snowflake" },
  { title: "Max Position Size", value: "5% equity", status: "Active", desc: "Blocks oversized entries", icon: "Scale" },
  { title: "Revenge-Trade Lock", value: "On", status: "Active", desc: "Detects tilt, locks new orders", icon: "Lock" },
  { title: "Session Window", value: "07:00–15:00", status: "Active", desc: "Only trade high-liquidity hours", icon: "Clock" },
  { title: "News Blackout", value: "±15 min", status: "Active", desc: "Pause around high-impact events", icon: "CalendarClock" },
];

// Analytics mock
export const analytics = {
  equityCurve: [100, 108, 104, 118, 126, 121, 138, 152, 147, 168, 181, 194],
  monthly: [
    { label: "Win Rate", value: "68%", delta: "+4%" },
    { label: "Avg R", value: "1.6R", delta: "+0.2R" },
    { label: "Profit Factor", value: "2.3", delta: "+0.3" },
    { label: "Max Drawdown", value: "-8.2%", delta: "-1.1%" },
  ],
  bestPairs: [
    { pair: "XRP/USDT", pnl: "+$1,240", trades: 22, win: 73 },
    { pair: "SOL/USDT", pnl: "+$890", trades: 18, win: 66 },
    { pair: "ETH/USDT", pnl: "+$610", trades: 15, win: 60 },
    { pair: "BTC/USDT", pnl: "-$180", trades: 24, win: 46 },
  ],
};

// Community mock
export const communityPosts = [
  { id: 1, user: "Aria Vance", rank: "Diamond", avatar: "AV", time: "2h", text: "Locked in +3.2R on XRP today. The Cool-Down Wall saved me from giving it all back. Discipline > everything.", likes: 128, comments: 24 },
  { id: 2, user: "Kenji Rao", rank: "Platinum", avatar: "KR", time: "5h", text: "Pattern-IQ rated my SOL setup a B+ and it played out perfectly. This tool is quietly elite.", likes: 96, comments: 12 },
  { id: 3, user: "Mara Ellis", rank: "Gold", avatar: "ME", time: "8h", text: "30 days journaling every trade. Win rate up from 51% to 64%. The data doesn't lie.", likes: 210, comments: 41 },
];

// Growth Zone mock
export const ranks = [
  { name: "Bronze", pct: 100, color: "#b08d57", reached: true },
  { name: "Silver", pct: 100, color: "#c0c8d4", reached: true },
  { name: "Gold", pct: 100, color: "#e6c25a", reached: true },
  { name: "Platinum", pct: 62, color: "#8fd3ff", reached: false, current: true },
  { name: "Diamond", pct: 0, color: "#7cc7ff", reached: false },
];

export const lessons = [
  { title: "Mastering the Cool-Down", mins: 6, tag: "Discipline", done: true },
  { title: "Reading Volatility Regimes", mins: 9, tag: "Market Structure", done: true },
  { title: "Position Sizing by Conviction", mins: 7, tag: "Risk", done: false },
  { title: "Building a Repeatable Edge", mins: 11, tag: "Strategy", done: false },
];

// Pair universe for the customizable Live Prices widget.
// `id` = unique key (Yahoo symbol), `tv` = TradingView symbol for the widget.
export const pairUniverse = [
  { id: "BTC-USD", tv: "BINANCE:BTCUSDT", label: "BTC/USD", cat: "Crypto" },
  { id: "ETH-USD", tv: "BINANCE:ETHUSDT", label: "ETH/USD", cat: "Crypto" },
  { id: "SOL-USD", tv: "BINANCE:SOLUSDT", label: "SOL/USD", cat: "Crypto" },
  { id: "XRP-USD", tv: "BINANCE:XRPUSDT", label: "XRP/USD", cat: "Crypto" },
  { id: "ADA-USD", tv: "BINANCE:ADAUSDT", label: "ADA/USD", cat: "Crypto" },
  { id: "DOGE-USD", tv: "BINANCE:DOGEUSDT", label: "DOGE/USD", cat: "Crypto" },
  { id: "AVAX-USD", tv: "BINANCE:AVAXUSDT", label: "AVAX/USD", cat: "Crypto" },
  { id: "LINK-USD", tv: "BINANCE:LINKUSDT", label: "LINK/USD", cat: "Crypto" },
  { id: "GC=F", tv: "OANDA:XAUUSD", label: "Gold (XAU)", cat: "Metals" },
  { id: "SI=F", tv: "OANDA:XAGUSD", label: "Silver (XAG)", cat: "Metals" },
  { id: "EURUSD=X", tv: "FX:EURUSD", label: "EUR/USD", cat: "Forex" },
  { id: "GBPUSD=X", tv: "FX:GBPUSD", label: "GBP/USD", cat: "Forex" },
  { id: "JPY=X", tv: "FX:USDJPY", label: "USD/JPY", cat: "Forex" },
  { id: "AUDUSD=X", tv: "FX:AUDUSD", label: "AUD/USD", cat: "Forex" },
  { id: "CAD=X", tv: "FX:USDCAD", label: "USD/CAD", cat: "Forex" },
  { id: "CHF=X", tv: "FX:USDCHF", label: "USD/CHF", cat: "Forex" },
  { id: "NZDUSD=X", tv: "FX:NZDUSD", label: "NZD/USD", cat: "Forex" },
  { id: "EURJPY=X", tv: "FX:EURJPY", label: "EUR/JPY", cat: "Forex" },
  { id: "GBPJPY=X", tv: "FX:GBPJPY", label: "GBP/JPY", cat: "Forex" },
  { id: "EURGBP=X", tv: "FX:EURGBP", label: "EUR/GBP", cat: "Forex" },
  { id: "^NDX", tv: "FOREXCOM:NSXUSD", label: "NAS100", cat: "Indices" },
  { id: "^DJI", tv: "FOREXCOM:DJI", label: "US30", cat: "Indices" },
  { id: "DX-Y.NYB", tv: "TVC:DXY", label: "DXY", cat: "Indices" },
];

export const defaultPairs = [
  "BTC-USD", "ETH-USD", "SOL-USD", "XRP-USD",
  "GC=F", "EURUSD=X", "GBPUSD=X", "JPY=X",
];

export const mockUser = {
  name: "Guest",
  initial: "G",
  status: "Sign in",
};

// ---- Added (inspired by tradelogs.com) — all MOCKED ----

// Scrolling ticker tape
export const tickerTape = [
  { symbol: "XAU/USD", price: "4,386", change: 0.84 },
  { symbol: "EUR/USD", price: "1.0891", change: -0.12 },
  { symbol: "GBP/USD", price: "1.2722", change: 0.34 },
  { symbol: "USD/JPY", price: "154.41", change: 0.21 },
  { symbol: "NAS100", price: "19,217", change: 1.05 },
  { symbol: "US30", price: "38,742", change: -0.07 },
  { symbol: "BTC/USD", price: "78,669", change: 2.41 },
  { symbol: "DXY", price: "104.18", change: -0.18 },
];

// Live session feed
export const liveFeedSeed = [
  { id: "f1", symbol: "GBP/USD", side: "BUY", setup: "Breakout", lots: "0.33", dur: "18m 22s", pnl: "+72.54", time: "12:18 UTC" },
  { id: "f2", symbol: "EUR/USD", side: "BUY", setup: "Pullback", lots: "0.34", dur: "9m 33s", pnl: "+295.88", time: "11:41 UTC" },
  { id: "f3", symbol: "NZD/USD", side: "BUY", setup: "Trend", lots: "0.37", dur: "24m 4s", pnl: "+77.27", time: "11:05 UTC" },
  { id: "f4", symbol: "AUD/USD", side: "SELL", setup: "Range", lots: "0.41", dur: "18m 22s", pnl: "-101.87", time: "10:44 UTC" },
  { id: "f5", symbol: "XAU/USD", side: "BUY", setup: "London", lots: "0.28", dur: "2h 05m", pnl: "+168.89", time: "10:12 UTC" },
];

export const liveSession = { netPnl: "+723.12", winRate: 71, winners: "5 of 7", streak: 3, trades: 8 };

// Behavioral score + trader profile radar
export const behavioralScore = {
  score: 88,
  delta: "+6",
  trend: "7-month trend",
  metrics: [
    { label: "Revenge trades", value: "2" },
    { label: "Impulse trades", value: "11%" },
    { label: "Plan followed", value: "94%" },
    { label: "Tilt risk", value: "Low" },
  ],
};

export const traderProfile = [
  { axis: "Discipline", value: 90 },
  { axis: "Patience", value: 72 },
  { axis: "Risk", value: 66 },
  { axis: "Timing", value: 60 },
  { axis: "Consistency", value: 78 },
  { axis: "Focus", value: 84 },
];

// P&L breakdowns
export const pnlBySymbol = [
  { symbol: "XAU/USD", pnl: 18200, label: "+$18.2k" },
  { symbol: "BTC/USD", pnl: 11300, label: "+$11.3k" },
  { symbol: "US500", pnl: 6800, label: "+$6.8k" },
  { symbol: "EUR/USD", pnl: 3100, label: "+$3.1k" },
  { symbol: "GBP/USD", pnl: -2000, label: "-$2.0k" },
  { symbol: "USD/JPY", pnl: -3200, label: "-$3.2k" },
];

export const pnlByDay = [
  { day: "Mon", pnl: 62 },
  { day: "Tue", pnl: -28 },
  { day: "Wed", pnl: 84 },
  { day: "Thu", pnl: 41 },
  { day: "Fri", pnl: 73 },
];

export const tradingSessions = [
  { name: "Asian", win: 54, pnl: "+$2.1k" },
  { name: "London", win: 73, pnl: "+$9.4k" },
  { name: "New York", win: 61, pnl: "+$5.2k" },
];

// Weekly review / tilt detection insight
export const weeklyReview = {
  time: "SESSION REVIEW · 4:15 PM",
  headline: "You size up right after a winner — watch your tilt cycle.",
  body: "Losses cluster after 3PM and your London longs are printing. Lock in the edge, cut the leak.",
  actions: [
    "Set a daily loss limit of $200",
    "Lock out after 3 losing trades",
    "Cap size to 1 lot on tilt",
  ],
};

// Chart replay (bar-by-bar) — synthetic candles for one trade
export const chartReplay = {
  pair: "XAU/USD",
  tf: "1H",
  side: "LONG",
  entryBar: 4,
  exitBar: 18,
  pnl: "+$1,193",
  bars: [
    4020, 4028, 4015, 4034, 4041, 4038, 4052, 4060, 4055, 4068,
    4072, 4066, 4080, 4092, 4088, 4101, 4110, 4124, 4118, 4132,
    4128, 4140,
  ],
};
